import { convertObjToQueryString } from "../../utils/helpers";

export const getUserCGMDeviceData = (
  queryObj: { [key: string]: any },
  userId: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_CGM_URL}/coach-panel/v1/home-page${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getCGMUserDetails = (
  queryObj: { [key: string]: any },
  userId: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_CGM_URL}/coach-panel/v1/cgm-user-details${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getCGMUsersList = () => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_CGM_URL}/coach-panel/v1/cgm-users-info`,
  };
};

export const addCoachNote = (
  queryObj: { [key: string]: any },
  data: { [key: string]: any },
  userId: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "POST",
    url: `${process.env.REACT_APP_CGM_URL}/coach-panel/v1/add-coach-note${query}`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};
